import {
    ErrorOutline as ErrorOutlineIcon,
} from '@mui/icons-material';

export type FormState = {
    email: string;
    verificationCode: string;
    newPassword: string;
    confirmPassword: string;
    id_usuario: number;
    isLoading: boolean;
    isSuccess: boolean;
    isCodeSent: boolean;
    isCodeVerified: boolean;
    isPasswordReset: boolean;
    error: string | null;
    isEmailValid: boolean;
    errorType: 'validation' | 'not-found' | 'server' | 'invalid-code' | 'password-mismatch' | 'weak-password' | null;
    resendCooldown: number;
    showNewPassword: boolean;
    showConfirmPassword: boolean;
}

export const getErrorSeverity = (formState: FormState) => {
    switch (formState.errorType) {
        case 'not-found':
            return 'warning';
        case 'server':
            return 'error';
        case 'invalid-code':
        case 'password-mismatch':
        case 'weak-password':
            return 'warning';
        case 'validation':
        default:
            return 'error';
    }
};

export const getErrorIcon = (formState: FormState) => {
    switch (formState.errorType) {
        case 'not-found':
        case 'invalid-code':
        case 'password-mismatch':
        case 'weak-password':
            return <ErrorOutlineIcon color='primary' />;
        default:
            return undefined;
    }
};